import { CSS_TABLE_COLUMNS } from "csi/constants";
import Path from "csi/table/matrix/Path";
import declare from "dojo/_base/declare";
import Spec from "csi/heading/Spec";
import locale from "csi/locale";

const CameraPositionMatrix = declare(Path, {
		
	/**
	 * @override
	 * Return specs for matrix with XYZ coordinates
	 */
	getColumnSpecs: function(ctx, h) {
		const subHeadings = ["AxisX", "AxisY", "AxisZ"];
		const specs = [];
		
		const subs = subHeadings.map((heading, i) => new Spec({				
			css: CSS_TABLE_COLUMNS,				
			heading: h,
			headerParams: {					
				innerText: locale.resource(heading),
				className: "headingCenter",
			},
			index: i,
		}));		
		
		var spec = new Spec({
			css: CSS_TABLE_COLUMNS,
			heading: h,
			headerParams: {
				colSpan: 3,
				innerText: h.m_name,
			},
			subs,
		});

		specs.push(spec);

		return specs;		
	},
});

export = CameraPositionMatrix;
